import { render, staticRenderFns } from "./langList.vue?vue&type=template&id=66978ba2&scoped=true"
import script from "./langList.vue?vue&type=script&lang=js"
export * from "./langList.vue?vue&type=script&lang=js"
import style0 from "./langList.vue?vue&type=style&index=0&id=66978ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66978ba2",
  null
  
)

export default component.exports